import { render, staticRenderFns } from "./EditModalSchool.vue?vue&type=template&id=5700281c&scoped=true"
import script from "./EditModalSchool.vue?vue&type=script&lang=js"
export * from "./EditModalSchool.vue?vue&type=script&lang=js"
import style0 from "./EditModalSchool.vue?vue&type=style&index=0&id=5700281c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5700281c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5700281c')) {
      api.createRecord('5700281c', component.options)
    } else {
      api.reload('5700281c', component.options)
    }
    module.hot.accept("./EditModalSchool.vue?vue&type=template&id=5700281c&scoped=true", function () {
      api.rerender('5700281c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/EditModalSchool.vue"
export default component.exports